import WidgetModel from '../widget-model'
import TextWidgetView from './text-widget-view'
import prepareRichText from 'scoreboard/components/rich-text/prepare-rich-text'

var TextWidget = WidgetModel.extend({
	viewCls: TextWidgetView,
	rotatable: true,

	containerDefaults: {
		width: 200,
		height: 120
	},

	defaults: function () {
		return {
			properties: {
				type: 'text'
			}
		}
	},

	multiSettableProps: [ 'background' ],
	canHaveOutline: true,

	/**
	 * Returns the rich text property for this widget, with some extra preparation
	 * that is done client-side (and thus not in the raw widget property)
	 */
	richText: function () {
		return prepareRichText(this.properties.get('text'))
	},

	isClickthrough() {
		return !this.drilldown()
	}


})

export default TextWidget

TextWidget.__filename__ = 'dashboards/widgets/text/text-widget-model.js'
